//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTime } from '../../components/helpers.js'
import Table from '../../components/Table/Table.vue'
import { settingsGUI } from '../../pages/main/sections/UserSettings/UserSettingsGUI.js'
import { axiosGet } from '../../axios/axios.js'
import { matchLocations } from './Sup/SupLocation.js'

export default {
  components: {
    Table
  },
  mixins: [settingsGUI],
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      loading: false,

      columns: [
        {
          name: 'name',
          label: 'Параметр',
          align: 'left',
          field: 'name',
          sortable: false
        },
        {
          name: 'initialValue',
          label: 'Значение при импорте',
          align: 'right',
          field: 'initialValue',
          sortable: false
        },
        {
          name: 'actualizedValue',
          label: 'Значение при актуализации',
          align: 'right',
          field: 'actualizedValue',
          sortable: false
        }
      ]
    }
  },
  computed: {
    supTaskData: function () {
      return this.request.supTaskData || {}
    },
    updateSupTaskDataAvailable: function () {
      return !!this.supTaskData.updateAvailable
    },
    supTaskInitialLocationValidationData: function () {
      const supTaskVersions = this.supTaskData.supTask
      const supTask = supTaskVersions && supTaskVersions.length && supTaskVersions[0] || null
      return matchLocations(supTask, this.request.location)
    },
    supTaskActualizedLocationValidationData: function () {
      const supTaskVersions = this.supTaskData.supTask
      const supTask = supTaskVersions && supTaskVersions.length > 1 && supTaskVersions[supTaskVersions.length - 1] || null
      return matchLocations(supTask, this.request.location)
    },
    propertiesData: function () {
      const properties = [
        { type: 'separator', key: 'supTask', name: 'Данные задачи ПТК АПТС' },
        { namespace: 'supTask', key: 'number', name: 'Номер задачи' },
        { namespace: 'supTask', key: 'taskName', name: 'Наименование  задачи' },
        { namespace: 'supTask', key: 'type', name: 'Тип задачи' },
        { namespace: 'supTask', key: 'address', name: 'Адрес' },
        { namespace: 'supTask', key: 'location', name: 'Координаты (из задачи)', format: this.formatLocation },
        { namespace: 'supTask', key: 'createTime', name: 'Дата/время создания задачи', format: formatTime },
        { namespace: 'supTask', key: 'updateTime', name: 'Дата/время изменения задачи', format: formatTime },
        { namespace: 'supTask', key: 'status', name: 'Статус задачи' },
        { namespace: 'supTask', key: 'updateStatusTime', name: 'Дата/время изменения статуса задачи', format: formatTime },
        { namespace: 'supTask', key: 'statusComment', name: 'Комментарий к статусу задачи' },
        { namespace: 'supTask', key: 'comment', name: 'Комментарий к задаче' },
        { namespace: 'supTask', key: 'registerTime', name: 'Дата/время регистрации в АС Дельта', format: formatTime, ignoreChanges: true },

        { type: 'separator', key: 'supAsset', name: 'Данные объекта инфраструктуры' },
        { namespace: 'supAsset', key: 'registerTime', name: 'Дата/время регистрации в АС Дельта', format: formatTime, ignoreChanges: true },
        { namespace: 'supAsset', key: 'type', name: 'Тип' },
        { namespace: 'supAsset', key: 'address', name: 'Адрес' },
        { namespace: 'supAsset', key: 'location', name: 'Координаты', format: this.formatLocation },
        { namespace: 'supAsset', key: 'createTime', name: 'Дата/время создания справочных данных', format: formatTime },
        { namespace: 'supAsset', key: 'updateTime', name: 'Дата/время изменения справочных данных', format: formatTime },

        { type: 'separator', key: 'supBeacon', name: 'Данные маяка' },
        { namespace: 'supBeacon', key: 'serial', name: 'Серийный номер маяка (из задачи)' },
        { namespace: 'supBeacon', key: 'id', name: 'ID маяка' },
        { namespace: 'supBeacon', key: 'status', name: 'Статус маяка (из задачи)' },
        { namespace: 'supBeacon', key: 'initTime', name: 'Дата/время активации маяка', format: formatTime },
        { namespace: 'supBeacon', key: 'updateTime', name: 'Дата/время изменения данных', format: formatTime },
        { namespace: 'supBeacon', key: 'updateStatusTime', name: 'Дата/время изменения статуса', format: formatTime }
      ]

      const supTaskData = this.supTaskData
      for (const property of properties) {
        if (property.type === 'separator') {
          property.uniqueKey = property.key
        } else {
          property.uniqueKey = property.namespace + '.' + property.key

          let initialValue = null
          let actualizedValue = null
          const namespaceRecords = supTaskData[property.namespace]
          if (namespaceRecords.length) {
            const initialNamespaceData = namespaceRecords[0]
            initialValue = this.getNamespaceValue(property, initialNamespaceData)

            if (namespaceRecords.length > 1) {
              const actualizedNamespaceData = namespaceRecords[namespaceRecords.length - 1]
              actualizedValue = this.getNamespaceValue(property, actualizedNamespaceData)

              property.valueChanged = initialValue !== actualizedValue
              if (namespaceRecords.length < 3) {
                property.valueHasOtherChanges = false
              } else {
                let changesCount = 0
                for (let i = 1; i < namespaceRecords.length; i++) {
                  const value = this.getNamespaceValue(property, namespaceRecords[i])
                  const prevValue = this.getNamespaceValue(property, namespaceRecords[i - 1])
                  if (value != prevValue) {
                    changesCount++
                    if (changesCount > 1) {
                      break
                    }
                  }
                }
                property.valueHasOtherChanges = changesCount > 1
              }
            }
          }
          property.initialValue = initialValue
          property.actualizedValue = actualizedValue
        }
      }

      return properties
    }
  },
  methods: {
    getNamespaceValue: function (property, namespaceDataRow) {
      let value
      if (property.format) {
        value = property.format(namespaceDataRow[property.key], namespaceDataRow)
      } else {
        value = namespaceDataRow[property.key]
      }
      return value
    },
    formatLocation: function (value, namespaceDataRow) {
      return this.formatCoords(this.convertLocation(namespaceDataRow.lon, namespaceDataRow.lat))
    },
    convertLocation: function (lon, lat) {
      return { lon, lat }
    },
    getCellClass: function (col, row) {
      if (col.name === 'actualizedValue' && (row.valueChanged || row.valueHasOtherChanges) && !row.ignoreChanges) {
        const classes = []
        if (row.valueChanged) {
          classes.push('text-blue-7')
          classes.push('text-weight-regular')
        }
        if (row.valueHasOtherChanges) {
          classes.push('bg-light-blue-1')
        }
        return classes.join(' ')
      }
      return undefined
    },

    onUpdateSupTaskData: function () {
      const params = new URLSearchParams()
      params.append('id', this.request.id)
      params.append('includeActions', true)

      this.loading = true
      return axiosGet({
        url: '/service/delta/request/updateSupTaskData?' + params.toString(),
        onSuccess: (response) => {
          // if (response.data.updated) {
          const supTaskData = response.data.result
          this.request.supTaskData = supTaskData

          this.$q.notify({
            type: 'positive',
            message: response.data && response.data.message || 'Интеграционные данные успешно обновлены',
            progress: true,
            timeout: 3000
          })
          // } else {
          //   this.$q.notify({
          //     type: 'warning',
          //     message: 'Нет изменений',
          //     progress: true,
          //     timeout: 3000
          //   })
          // }
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response && response.message || 'Ошибка обновления интеграционных данных',
            progress: true,
            timeout: 3000
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

